module.exports = __webpack_public_path__ + "static/media/dk.0666b274.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/dk.svg
// module id = 2077
// module chunks = 0